/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

export const beforeCardRenderAccessbility = (slick, cbrModal) => {
  slick.track &&
    slick.track.querySelectorAll('div[aria-hidden="true"]').forEach((elm, index) => {
      elm.querySelectorAll('a').forEach((e, i) => {
        let slideStatus = e.classList && e.classList.contains('collectionpaging_wrapper');
        !cbrModal && !slideStatus && e.setAttribute('tabindex', '0');
      });
      elm.querySelectorAll('[tabindex="-1"]').forEach((e, i) => {
        let slideStatus = e.classList && e.classList.contains('collectionpaging_wrapper');
        !cbrModal && !slideStatus && e.setAttribute('tabindex', '0');
      });
    });
  // //Remove social card and articleIframe hidden Class before card shows in
  // carousal
  setTimeout(function () {
    slick.track &&
      slick.track.querySelectorAll('div[aria-hidden="false"]').forEach((elm, index) => {
        elm.querySelectorAll('.social-twtr-card').forEach((e, i) => {
          e.classList.remove('hideSocialCard');
        });
        elm.querySelectorAll('.iframeSwipe iframe').forEach((e, i) => {
          e.classList.remove('hideSocialCard');
        });
      });
    slick.track &&
      slick.track.querySelectorAll('div[aria-hidden="true"]').forEach((elm, index) => {
        elm.querySelectorAll('.social-twtr-card').forEach((e, i) => {
          e.classList.add('hideSocialCard');
        });
        elm.querySelectorAll('.iframeSwipe iframe').forEach((e, i) => {
          e.classList.add('hideSocialCard');
        });
      });
  }, 500);
};
export const afterChangeAccessbility = (slick, nextSlide, prevSlide, nextPrevType, cbrModal) => {
  !!nextPrevType
    ? slick.track && slick.track.classList.remove('nofocus')
    : slick.track && slick.track.classList.add('nofocus');
  slick.slides &&
    slick.slides.forEach((e, i) => {
      e.setAttribute('tabindex', '-1');
    });
  let slickActive = slick.track && slick.track.querySelector('.slick-active');
  slickActive && slickActive.setAttribute('tabindex', 0);
  let muContent = slickActive && slickActive.querySelector('.mu-content');
  let focuscbrModal = slickActive && slickActive.querySelector('.small-modal__innercontent');
  if (muContent && !cbrModal) {
    muContent.focus();
  } else if (focuscbrModal && cbrModal) {
    focuscbrModal.focus();
    const getcurrentSlide =
      slickActive && slickActive.querySelector('.collection-allCard__Wrapper');
    const anchor = getcurrentSlide && getcurrentSlide.querySelectorAll('a');
    if (anchor) {
      anchor.forEach((i) => {
        i.setAttribute('tabindex', '-1');
      });
    }
    const tabIndex = getcurrentSlide && getcurrentSlide.querySelectorAll("[tabindex='0']");
    if (tabIndex) {
      tabIndex.forEach((i) => {
        i.setAttribute('tabindex', '-1');
      });
    }
  } else {
    let iframeSwipe = slickActive && slickActive.querySelector('.iframeSwipe');
    if (iframeSwipe) {
      let iframedom = document.querySelectorAll('.iframedom');
      iframedom &&
        iframedom.forEach((e, i) => {
          e.setAttribute('tabindex', '-1');
        });
      iframedom &&
        iframedom.forEach((e, i) => {
          e.setAttribute('aria-hidden', 'true');
        });
      iframeSwipe.focus();
    } else {
      muContent && muContent.focus();
    }
  }
  if (nextSlide) {
  }
  if (prevSlide) {
  }
};
export const afterCardRenderAccessibility = (slick, cbrModal) => {
  let AreaHiddenTrue = slick.track && slick.track.querySelectorAll('div[aria-hidden="true"]');
  if (AreaHiddenTrue) {
    AreaHiddenTrue.forEach((elm, index) => {
      elm.querySelectorAll('a').forEach((el, idx) => {
        el.setAttribute('tabindex', '-1');
      });
      elm.querySelectorAll('[tabindex="0"]').forEach((el, idx) => {
        el.setAttribute('tabindex', '-1');
      });
      elm.querySelectorAll('button').forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });
    });
  }
  let slickCurrent = slick.track && slick.track.querySelector('.slick-current');
  if (slickCurrent) {
    let adAnchors = slickCurrent.querySelectorAll('.dfp-ads-card.mu-content a');
    if (adAnchors) {
      adAnchors.forEach((elm, index) => {
        elm.querySelectorAll('[tabindex="0"]').forEach((el, idx) => {
          el.setAttribute('tabindex', '-1');
        });
      });
    }
    const firstAnchor = slickCurrent.querySelector('.dfp-ads-card.mu-item a.dfp-ads-card-anchor');
    const imgholder = firstAnchor && firstAnchor.querySelector('.img-holder');
    if (firstAnchor) {
      firstAnchor.setAttribute('tabindex', '-1');
      imgholder && imgholder.setAttribute('tabindex', '-1');
    }
  }
};

export const onLoadAccessibility = (slick, cbrModal) => {
  setTimeout(() => {
    const sliderWrapper =
      slick.track &&
      slick.track.querySelectorAll('div[aria-hidden="false"] .collection-allCard__Wrapper');
    if (cbrModal && sliderWrapper) {
      sliderWrapper.forEach((elm, index) => {
        elm.querySelectorAll('a').forEach((e, i) => {
          e.setAttribute('tabindex', '-1');
        });
        elm.querySelectorAll('[tabindex="0"]').forEach((e, i) => {
          e.setAttribute('tabindex', '-1');
        });
      });
    } else if (!cbrModal && sliderWrapper) {
      sliderWrapper.forEach((elm, index) => {
        elm.querySelectorAll('[tabindex="-1"]').forEach((e, i) => {
          e.setAttribute('tabindex', '0');
        });
        const firstAnchor = elm.querySelector('.dfp-ads-card.mu-item a.dfp-ads-card-anchor');
        if (firstAnchor) {
          const imgholder = firstAnchor.querySelector('.img-holder');
          firstAnchor.setAttribute('tabindex', '-1');
          imgholder && imgholder.setAttribute('tabindex', '-1');
        }
      });
    }
  }, 500);
};

export const CollectionDialog = (dialogEl, type, slick) => {
  let _selfDialog = {};
  _selfDialog.dialogEl = dialogEl;
  _selfDialog.contentType = type;
  _selfDialog.focusedElBeforeOpen = document.activeElement;
  let focusableEls;
  if (_selfDialog.dialogEl) {
    if (_selfDialog.contentType === 'collectionModal') {
      focusableEls = _selfDialog.dialogEl.querySelectorAll(
        '.collection_modal .accessibilityCloseModal, .modalShareLink'
      );
      _selfDialog.focusableEls = Array.prototype.slice.call(focusableEls);
      _selfDialog.firstFocusableEl = _selfDialog.focusableEls[0];
      _selfDialog.lastFocusableEl = document.querySelector('.modalShareLink');
    } else if (_selfDialog.contentType === 'carousalDialog') {
      focusableEls = _selfDialog.dialogEl.querySelectorAll(
        '.collection_modal .accessibilityCloseModal, .slick-prev.slick-arrow, .slick-next.slick-arrow'
      );
      _selfDialog.focusableEls = Array.prototype.slice.call(focusableEls);
      _selfDialog.firstFocusableEl = _selfDialog.focusableEls[0];
      _selfDialog.lastFocusableEl = _selfDialog.focusableEls[_selfDialog.focusableEls.length - 1];
    }
    open(_selfDialog, slick);
  }
};
const open = (_selfDialog, slick) => {
  _selfDialog.dialogEl.addEventListener('keydown', (e) => {
    _handleKeyDown(e, _selfDialog, slick);
  });
};

const _handleKeyDown = (e, _selfDialog, slick) => {
  var KEY_TAB = 9;
  // var KEY_UP_ARROW = 38,
  //   KEY_DOWN_ARROW = 40;
  let slickCurrent = slick.track && slick.track.querySelector('.slick-current');
  let hasLimitedAccess = slickCurrent && slickCurrent.querySelector('.hasLimitedAccess');
  hasLimitedAccess && hasLimitedAccess.classList.remove('article-iframe-focus');
  const handleBackwardTab = () => {
    var slickNextElm = slick.nextArrow;
    var slickPrevElm = slick.prevArrow;
    var downArrElm = hasLimitedAccess && hasLimitedAccess;
    if (document.activeElement === _selfDialog.firstFocusableEl) {
      e.preventDefault();
      _selfDialog.lastFocusableEl.focus();
    } else if (_selfDialog.contentType === 'carousalDialog') {
      if (document.activeElement === slickNextElm) {
        if (hasLimitedAccess) {
          setTimeout(function () {
            hasLimitedAccess.focus();
            hasLimitedAccess.classList.add('article-iframe-focus');
          }, 100);
        }
      } else if (downArrElm && document.activeElement === downArrElm) {
        slickPrevElm.focus();
      }
    }
  };
  const handleForwardTab = () => {
    var shareElm = slickCurrent && slickCurrent.querySelectorAll('.modalShareLink');
    var prevSlickBtn = slick.prevArrow;
    if (document.activeElement === _selfDialog.lastFocusableEl) {
      e.preventDefault();
      _selfDialog.firstFocusableEl.focus();
    } else if (shareElm.length) {
      if (document.activeElement === shareElm[0]) {
        _selfDialog.lastFocusableEl.focus();
      }
    } else if (document.activeElement === prevSlickBtn[0]) {
      if (hasLimitedAccess) {
        setTimeout(function () {
          hasLimitedAccess.focus();
          hasLimitedAccess.classList.add('article-iframe-focus');
        }, 100);
      }
    }
  };
  switch (e.keyCode) {
    case KEY_TAB:
      if (_selfDialog.focusableEls.length === 1) {
        e.preventDefault();
        break;
      }
      if (e.shiftKey) {
        handleBackwardTab();
      } else {
        handleForwardTab();
      }
      break;
    // case KEY_UP_ARROW:
    //   handleBackwardTab();
    // case KEY_DOWN_ARROW:
    //   handleForwardTab();
    default:
      break;
  }
};
